import { defineComponent as f, useCssModule as b, createElementBlock as r, openBlock as d, normalizeClass as n, unref as a, renderSlot as u, createCommentVNode as v, withModifiers as m, withKeys as _, createVNode as w } from "vue";
import C from "./utils/colorScheme.js";
import y from "./Icon.js";
import { _ as $ } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const z = ["disabled"], k = /* @__PURE__ */ f({
  name: "ll-chip",
  __name: "Chip",
  props: {
    colorScheme: { default: "ice" },
    shade: { default: "light" },
    size: { default: "medium" },
    radius: { default: "standard" },
    bgColor: { default: void 0 },
    textColor: { default: void 0 },
    isRemovable: { type: Boolean, default: !1 },
    shouldOverrideColors: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["click", "remove"],
  setup(c, { emit: p }) {
    const e = c, i = p, s = b();
    function h() {
      const { computedBgColor: o, computedTextColor: t } = C({
        shade: e.shade,
        color: e.colorScheme
      }), l = `tw-text-${e.textColor || t} tw-bg-${e.bgColor || o}`;
      return {
        "tw-rounded-none": e.radius === "none",
        "tw-rounded-sm": e.radius === "standard",
        "tw-rounded-full": e.radius === "pill",
        [l]: !e.shouldOverrideColors && !e.disabled,
        "tw-bg-ice-500 tw-text-white": e.disabled
      };
    }
    return (o, t) => (d(), r("span", {
      class: n(["stash-chip tw-relative tw-inline-flex tw-items-center", [
        `stash-chip--radius-${e.radius}`,
        `stash-chip--size-${e.size}`,
        `stash-chip--shade-${e.shade}`,
        a(s).root,
        a(s).removableChip,
        a(s)[`size-${e.size}`],
        h()
      ]]),
      "data-test": "stash-chip",
      onClick: t[2] || (t[2] = (l) => i("click"))
    }, [
      o.isRemovable ? (d(), r("span", {
        key: 0,
        class: n([{ "tw-mr-6 tw-truncate": e.isRemovable }])
      }, [
        u(o.$slots, "default")
      ], 2)) : u(o.$slots, "default", { key: 1 }),
      e.isRemovable ? (d(), r("button", {
        key: 2,
        tabindex: "-1",
        class: n(["stash-chip__remove-button", ["tw-absolute", a(s)["remove-button"]]]),
        "data-test": "stash-chip|remove-button",
        disabled: e.disabled,
        onKeypress: t[0] || (t[0] = _(m((l) => i("remove"), ["prevent"]), ["enter"])),
        onMousedown: t[1] || (t[1] = m((l) => i("remove"), ["prevent", "stop"]))
      }, [
        w(y, {
          "data-test": "icon|close",
          name: "close",
          size: "small"
        })
      ], 42, z)) : v("", !0)
    ], 2));
  }
}), x = "_root_1u8h2_2", g = {
  root: x,
  "size-medium": "_size-medium_1u8h2_12",
  "size-small": "_size-small_1u8h2_17",
  "remove-button": "_remove-button_1u8h2_22"
}, B = {
  $style: g
}, N = /* @__PURE__ */ $(k, [["__cssModules", B]]);
export {
  N as default
};
//# sourceMappingURL=Chip.js.map
